module.exports = __webpack_public_path__ + "img/img-program.2f6a68a3.png";